import { apiPost, apiPostWithCustomToken, apiPostWithMultiPart } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
    signUp: (payload) => apiPost(domainUrl('/v1/auth/hospital-register'), payload),
    login: (payload) => apiPost(domainUrl('/v1/auth/login'), payload),
    logout: (payload) => apiPost(domainUrl('/v1/auth/logout'), payload),
    forgetPassword: (payload) => apiPost(domainUrl('/v1/auth/forgot-password'), payload),
    resetPassword: (payload) => apiPost(domainUrl('/v1/auth/reset-password'), payload),

    verifyTotp: (payload) => apiPost(domainUrl('/v1/auth/verify-totp'), payload),
    sendOtp: (payload) => apiPostWithCustomToken(domainUrl('/v1/auth/send-otp'), payload),
    verifyOtp: (payload) => apiPost(domainUrl('/v1/auth/verify-otp'), payload),


    disableMfaUser: (payload) => apiPost(domainUrl('/v1/auth/disable-mfa-users'), payload),
    resendInviteEmail: (payload) => apiPost(domainUrl('/v1/auth/resend-invite-users'), payload),
    resetPasswordUsers: (payload) => apiPost(domainUrl('/v1/auth/reset-password-users'), payload),
    changePassword: (payload) => apiPost(domainUrl(`/v1/auth/change-password`), payload),
}
